// saved list actions
export const DELIVERY_METHODS = {
  PICKUP: "PICKUP",
  SHIPPING: "SHIPMENT",
  DELIVERY: "DELIVERY",
};
